// extracted by mini-css-extract-plugin
module.exports = {"headerInside":"nav-module--headerInside--1XJe4","active":"nav-module--active--3rHXt"};